export default __webpack_public_path__ + "static/media/Likewise_Flooring_Vesta_Vinyl_Banner_Mobile.8bc5c78e.jpg";